export default "__VITE_ASSET__a408627b__"